export default __webpack_public_path__ + "static/media/gs8-HA-facing-user-flow.fefce8e8.jpg";